module.exports = __webpack_public_path__ + "static/media/CredIESMedNew.5de46a35.svg";